import auth from '@/f1/service/auth';

export default {
  data: () => ({ remember_username: false, m: { username: '', password: '' }, lock: false, }),
  methods: {
    // reset() { this.$router.push({ name: 'auth_reset'}); },
    // regist() { this.$router.push({ name: 'auth_register'}); },
    async login() {
      if(_.isEmpty(this.m.username)) { return this.$toastr.e('Username required.'); }
      if(_.isEmpty(this.m.password)) { return this.$toastr.e('Password required.'); }
      if(this.lock) { return this.$toastr.i('Please wait, I\'m trying to login.'); }
      this.lock = true;
      try {
        this.$toastr.i('Try to login.');
        await auth.login(this.m.username, this.m.password);
        // 아이디 저장여부
        if(this.remember_username) { window.localStorage.setItem('username', this.m.username); } else { window.localStorage.removeItem('username'); }
        this.$router.replace(this.$route.query.redirect || '/'); // 대시보드 경로로 변경 필요함
      } catch(e) { this.$toastr.e(e.data && (e.data.message || e.data) || 'unexpected error.'); console.log(e); }
      this.lock = false;
    }
  },
  created() { auth.logout(); this.$router.push('/login'); },
  destroyed() { console.log('[vue] login', 'destroyed'); },
  mounted() {
    console.log('[vue] login', 'mounted');
    if(auth.isAuthenticated()) { this.$router.replace('/');  } // 대시보드 경로로 변경 필요함
    if(window.localStorage.getItem('username')) { this.checked = true; this.m.username = window.localStorage.getItem('username'); }
  }
}